'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout     from '@Layout/BackOffice'
import UpdateForm from '@/Form/UpdateForm'
import _config     from '@Config/Blog/blog'

const { app } = window;

let config = _.cloneDeep(_config);

config.fields =
{
	disabled:
	{
		label: 'Désactiver l\'article',
		type: 'checkbox',
		front_indicator: true
	},

	...config.fields
};

config.hookComponentWillMount = function ()
{
	const component = this, props = this.props, state = this.state;

	let form_data = component.state.form_data;

	form_data['blog[type]'] = 'synergies';

	component.setState(
	{
		form_data: form_data
	});
};

export default class AdminBlogPage extends Component
{
	state = { };

	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	render ()
	{
		const props = this.props;

		const output =
		(
			<Layout page_title="Article de blog Synergies" history={ props.history }>

				<div className="page-content">

					<div className="o-content">

						<TransitionGroup className="page-form-container
							synergies-blog-form">

							<CSSTransition
								classNames="a-form-transition"
								appear={ true }
								enter={ true }
								exit={ true }
								timeout={ { enter: 240, exit: 320, appear: 500 } }>

								<UpdateForm config={ config } />

							</CSSTransition>

						</TransitionGroup>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}